import { render, staticRenderFns } from "./form.vue?vue&type=template&id=a0b2a974&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b2a974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0b2a974')) {
      api.createRecord('a0b2a974', component.options)
    } else {
      api.reload('a0b2a974', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=a0b2a974&scoped=true", function () {
      api.rerender('a0b2a974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/conversations/send-list/form.vue"
export default component.exports